module.exports = __webpack_public_path__ + "img/emo_42.998ce306.png";